export default "__VITE_ASSET__lwPbgWDK__"